
const routes = [
  {
    path: "/reports",
    name: "reports",
    component: () => import(/* webpackChunkName: "ReportsPage" */ "./views/ReportsPage")
  },
  {
    path: "/reports/:codeName",
    name: "report",
    component: () => import(/* webpackChunkName: "ReportPage" */ "./views/ReportPage")
  }
];

export default routes;
